<template>
  <div class="container1400">
    <v-skeleton-loader
      v-if="loading"
      type="article"
      class="mt-10"
    ></v-skeleton-loader>
    <v-container fluid v-if="!loading">
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
        </ul>
      </v-alert>
      <div v-if="list">
        <div v-if="list.property_id">
          <v-card height="100%" elevation="0" class="pa-5">
            <h1 class="text-h4 font-weight-medium mt-5 mb-5">
              {{ $t("CancelBookingTitle") }}
            </h1>
            <v-row>
              <v-col>
                <div class="subtitle-2 mb-2">
                  {{ $t("TripStatus") }} : {{ $t(list.booking_status) }}
                </div>
                <div class="subtitle-2 mb-2">
                  {{ $t("Tripid") }} : {{ list._id }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" cols="12">
                <h2 class="text-h5">
                  {{ list.property_id.name }}
                </h2>
                <div class="pb-5 text-capitalize">
                  <span>
                    <v-icon small class="gray--text"
                      >mdi-map-marker-radius</v-icon
                    >
                    {{ list.property_id.location }}
                  </span>
                </div>
                <h2 class="text-h6 pb-2">{{ $t("TripDetails") }}</h2>
                <v-row>
                  <v-col cols="4">
                    <div class="overline grey--text">
                      {{ $t("Checkin") }}
                    </div>
                    <div class="subtitle-2">
                      {{
                        format(
                          new Date(list.booking_details.dates[0] + "T00:00"),
                          "eee, do MMM, yyyy"
                        )
                      }}
                      - {{ list.booking_details.check_in_time }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="overline grey--text">
                      {{ $t("Checkout") }}
                    </div>
                    <div class="subtitle-2">
                      {{
                        format(
                          new Date(list.booking_details.dates[1] + "T00:00"),
                          "eee, do MMM, yyyy"
                        )
                      }}
                      - {{ list.booking_details.check_out_time }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="overline grey--text">
                      {{ $t("BookedFor") }}
                    </div>
                    <div class="subtitle-2">
                      {{ list.booking_details.no_days }}
                      {{ $t("Nights") }}
                    </div>
                  </v-col>
                </v-row>
                <h2 class="text-h6 mt-5 pb-3">{{ $t("Paymentdetails") }}</h2>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="list.application_fee.amount > '0'">
                        <td class="pa-1">
                          {{ $t("Securitydeposit") }}:
                          {{ list.booking_details.currency_code }}
                          {{ list.application_fee.amount }}
                        </td>
                        <td class="text-right">
                          {{ list.application_fee.status }}
                        </td>
                      </tr>
                      <tr v-for="(item, i) in list.payments" :key="i">
                        <td class="pa-1">
                          {{ item.currency_code }} {{ item.amount }}
                          <div class="caption mb-1">
                            {{ $t("BookingFee") }}:
                            {{ item.currency_code }}
                            {{ item.nomad_fee }}
                          </div>
                          <div class="caption mb-1">
                            {{ $t("CleaningFee") }}:
                            {{ item.currency_code }}
                            {{ item.cleaning_fee }}
                          </div>
                        </td>
                        <td class="text-right">
                          {{ item.payment_status }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col md="6" cols="12" class="pl-10 pt-0 pb-0">
                <h2 class="text-h6 mt-7">
                  {{ $t("CancelReason") }}
                </h2>
                <div class="subtitle-2 grey--text mb-5">
                  {{ $t("CBmsg1") }}
                </div>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        dense
                        outlined
                        v-model="reason"
                        :rules="reqRules"
                        :label="$t('CancelReason')"
                        rows="3"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <div class="subtitle-2 pb-3">
                    {{ $t("CBmsg2") }}
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-btn color="red" dark @click="cancelBooking">
                        {{ $t("RequestCancellation") }}
                      </v-btn>
                      <v-btn
                        color="light-blue"
                        text
                        :to="{
                          name: 'PartnerBookingViewComponent',
                          params: { id: parm }
                        }"
                      >
                        {{ $t("Nevermind") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import { format } from "date-fns";
import PartnerService from "@/services/PartnerService";

export default {
  name: "CancelBooking",
  mixins: [timeoutMixin],
  components: {},
  data() {
    return {
      format,
      list: null,
      error: null,
      valid: false,
      dialog: false,
      loading: true,
      reason: "",
      parm: this.$route.params.id,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  created: function() {
    PartnerService.viewCancelBooking({
      id: this.parm
    })
      .then(async result => {
        this.list = result.data.list;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    async cancelBooking() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        PartnerService.cancelBooking({
          id: this.list._id,
          type: this.list.pay_type,
          reason: this.reason
        })
          .then(() => {
            this.$router.push({
              name: "PartnerBookingViewComponent",
              params: { id: this.list._id }
            });
          })
          .catch(err => {
            this.loading = false;
            this.error = err.response.data.errors;
          });
      }
    }
  }
};
</script>

<style></style>
